enum FileReaderEventTypeEnum {
	abort = 'abort',
	error = 'error',
	load = 'load',
	loadstart = 'loadstart',
	loadend = 'loadend',
	progress = 'progress'
}
export default FileReaderEventTypeEnum;
